const excludeFields = [
  "acl",
  "password",
  "middleName",
  "nickName",
  "mobileNumber",
  "birthDate",
  "birthPlace",
  "sex",
  "age",
  "family_order",
  "height",
  "weight",
  "bloodType",
  "citizenship",
  "languageWritten",
  "permanent_houseNumber",
  "permanent_street",
  "permanent_subdivision",
  "permanent_barangay",
  "permanent_city",
  "permanent_province",
  "permanent_zipCode",
  "telephone",
  "present_houseNumber",
  "present_street",
  "present_subdivision",
  "present_barangay",
  "present_city",
  "present_province",
  "present_zipCode",
  "present_telephone",
  "sss",
  "philHealth",
  "pagIbig",
  "tin",
  "agencyNumber",
  "schoolNameElem",
  "addressElem",
  "yearStartDateElem",
  "yearEndDateElem",
  "awardReceivedElem",
  "schoolNameHs",
  "addressHs",
  "yearStartDateHs",
  "yearEndDateHs",
  "awardReceivedHs",
  "schoolNameCol",
  "addressCol",
  "yearStartDateCol",
  "yearEndDateCol",
  "degreeCourse",
  "awardReceivedCol",
  "isFreshGrad",
  "employmentBackground",
  "characterReferences",
  "diploma",
  "reportCard",
  "tor",
  "coe",
  "trainingCertificate",
  "email",
  "employee",
  "relativeLGS",
  "relativeClient",
  "newStartDateTime",
  "newEndDateTime",
  "positionDesired",
  "area",
  "coordinator",
  "onBoardDate",
  "onBoardStartTime",
  "onBoardEndTime",
  "hireStartDate",
  "hireEndDate",
  "applicant",
  "recruiter",
  "image1",
  "image2",
  "interviewCoordinator",
  "employmentStatus",
  "contact_name",
  "contact_houseNumber",
  "contact_street",
  "contact_subdivision",
  "contact_barangay",
  "contact_city",
  "contact_province",
  "contact_zipCode",
  "contact_telephone",
  "contact_relationship",
  "remarks",
  "previousRecruiter",
  "onBoardRemarks",
  "pollRemarks",
  "termsAgreed",
  "signature",
  "orientationDate",
  "deploymentType",
  "seeLGS",
  "additionalEmail",
  "hireDate",
  "startDate",
  "deployedAt",
  "endDate",
  "medicalValidDate",
  "mayorPermitValidDate",
  "healthPermitValidDate",
  "nbiValidDate",
  "policeClearanceValidDate",
  "interviewForm",
  "prevInterviewForm",
  "rejectionReason",
];

export default excludeFields;
